import ClipLoader from "react-spinners/ClipLoader";
import '../../css/spinner.css';

function Spinner() {

  return (
    <div className="sweet-loading">
      <ClipLoader
        color="#f6d365"
        loading="true"
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default Spinner;